import React, { Component } from 'react';
import * as BasicComponents from '../basic';
import * as ExternalBasic from '../../../../common/components/basic';
import FileUpload from '../file-upload'
const BasicComponentsMap = {};
for (var attr in BasicComponents)
    BasicComponentsMap[attr.toLocaleLowerCase()] = BasicComponents[attr];
for (var attr in ExternalBasic)
    BasicComponentsMap[attr.toLocaleLowerCase()] = ExternalBasic[attr];
BasicComponentsMap.fileupload = FileUpload;

export default class DefineModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            config: props.config || []
        };
        this.vm = props.viewModel;
        this.init(this.state.config, this.vm);
    }
    init = (config, vm) => {
        config.forEach(ele => {
            for (var key in ele) {
                if (key != 'iCols') this.addProperty(key, ele[key]);
            }
        });
        vm.clear();
    }
    addProperty = (itemName, config) => {
        const { cControlType } = config;
        let controlType = cControlType && cControlType.trim().toLocaleLowerCase();
        let model = null;
        switch (controlType) {
            case 'refer':
            case 'treerefer':
            case 'listrefer':
            case 'tagrefer':
            case 'searchrefer':
                model = new cb.models.ReferModel(cb.utils.extend(true, {}, config));
                break;
            case 'select':
            case 'tagbutton':
            case 'radio':
            case 'predicatedatepicker':
                model = new cb.models.ListModel(cb.utils.extend(true, {}, config));
                break;
            case 'fileupload':
                model = new cb.models.TagModel(cb.utils.extend(true, {}, config));
                break;
            default:
                model = new cb.models.SimpleModel(cb.utils.extend(true, {}, config));
                break;
        }
        this.vm.addProperty(itemName, model);
    }
    getControl = () => {
        let config = this.state.config;
        const controls = [];
        let iCols = 1;
        config.forEach(ele => {
            for (var key in ele) {
                if (key != 'iCols') {
                    let controlWidth = 100 / iCols;
                    const controlCols = ele[key].iColWidth || 1;
                    if (controlCols > iCols)
                        controlWidth = 100;
                    else if (controlCols > 1)
                        controlWidth *= controlCols;
                    const { cControlType } = ele[key];
                    let controlType = cControlType && cControlType.trim().toLocaleLowerCase();
                    const ComName = BasicComponentsMap[controlType];
                    const model = this.vm.get(key);
                    const component = ComName ? <ComName model={model} {...ele[key]} /> : <h1>{controlType}</h1>;
                    const className = `viewSetting viewCell width-percent-${controlWidth.toFixed(0)}`;
                    controls.push(
                        <div className={className}>
                            {component}
                        </div>
                    )
                } else {
                    iCols = ele[key];
                }
            }
        });
        return controls;
    }
    render() {
        return (
            <div className='yxy_define_modal_container'>{this.getControl()}</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/meta/DefineModal.jsx